import { render, staticRenderFns } from "./CardHoverOverlay.vue?vue&type=template&id=15f6560d&"
import script from "./CardHoverOverlay.vue?vue&type=script&lang=js&"
export * from "./CardHoverOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports